import { LogoFileExtntionRequest, LogoFileExtntionResponse } from "../../views/Profile/AddRestaurant";
import { apiSlice } from "../apiSlice";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN || process.env.REACT_APP_API_BASE_DOMAIN_PROD || process.env.REACT_APP_API_BASE_DOMAIN_DEV;

export interface PromotionItem {
    type: "MenuItem" | "SetMenu" | "CustomMenu";
    itemId: string;
}

interface createPromotionRequest {
    restaurantId: string;
    title?: string | undefined;
    description?: string | undefined;
    imageUrl: string;
    type: string;
    subType?: string | undefined;
    pointsToRupeeConversionRate?: number | undefined;
    rupeeToPointConversionRate?: number | undefined;
    minimumBillTotal: number;
    value: number;
    code: string;
    expiresAt: string;
    appliedTo: string;
    isPublic: boolean;
    items?: PromotionItem[];
    filterTags?: string[];
}

interface UpdatePromotionRequest {
    restaurantId: string;
    promotionId: string;
    title?: string | undefined;
    description?: string | undefined;
    type: string;
    subType?: string | undefined;
    pointsToRupeeConversionRate?: number | undefined;
    rupeeToPointConversionRate?: number | undefined;
    minimumBillTotal: number;
    value: number;
    code: string;
    expiresAt: string;
    appliedTo: string;
    isPublic: boolean;
    items?: PromotionItem[];
    filterTags?: string[];
}



export interface AvailabilityStatus {
    restaurantId: string;
    promotionId: string;
    isActive: boolean;
}

export interface DeletePromotionRequest {
    restaurantId: string;
    promotionId: string;
}

export interface PromotionImageUpdateRequest {
    imgRef: string;
    restaurantId: string;
    promotionId: string;
}

export const PromotionService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPromotionTypeList: builder.query({
            query: () => `https://adminhttps-getpromotiontypes${API_BASE_DOMAIN}`,
        }),
        createPromotion: builder.mutation<any, createPromotionRequest>({
            query: (data) => ({
                url: `https://adminhttps-createpromotion${API_BASE_DOMAIN}`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),
        UploadPromotionLogoFileExtntionHttps: builder.mutation<
            LogoFileExtntionResponse,
            LogoFileExtntionRequest
        >({
            query: (data) => ({
                url: `https://adminhttps-getpromotionlogouploadurl${API_BASE_DOMAIN}/`,
                method: "POST",
                body: data,
            }),
        }),
        getPromotionList: builder.query({
            query: (restaurantId) =>
                `https://adminhttps-getpromotionlistforrestaurant${API_BASE_DOMAIN}?restaurantId=${restaurantId}`,
        }),
        updatePromotionAvailabilityStatus: builder.mutation<string, AvailabilityStatus>({
            query: (data) => ({
                url: `https://adminhttps-updatepromotionavailability${API_BASE_DOMAIN}/`,
                method: "POST",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),
        deletePromotion: builder.mutation<any, { restaurantId: string; promotionId: string }>({
            query: ({ restaurantId, promotionId }) => ({
                url: `https://adminhttps-deletepromotion${API_BASE_DOMAIN}?restaurantId=${restaurantId}&promotionId=${promotionId}`,
                method: "DELETE",
            }),
        }),
        getPromotionDetailsById: builder.mutation<any, { restaurantId: string; promotionId: string }>({
            query: ({ restaurantId, promotionId }) => ({
                url: `https://adminhttps-getpromotionbyid${API_BASE_DOMAIN}?promotionId=${promotionId}&restaurantId=${restaurantId}`,
            }),
        }),
        updatePromotion: builder.mutation<any, UpdatePromotionRequest>({
            query: (data: UpdatePromotionRequest) => ({
                url: `https://adminhttps-updatepromotion${API_BASE_DOMAIN}`,
                method: "PUT",
                body: data,
                responseHandler: (response) => response.text(),
            }),
        }),
        updatePromotionImage: builder.mutation<any, PromotionImageUpdateRequest>({
            query: (requestData) => ({
                url: `https://adminhttps-updatepromotionimage${API_BASE_DOMAIN}/`,
                method: "POST",
                body: requestData,
                responseHandler: (response) => response.text(),
            }),
        }),
    }),
});

export const {
    useGetPromotionTypeListQuery,
    useLazyGetPromotionTypeListQuery,
    useCreatePromotionMutation,
    useUploadPromotionLogoFileExtntionHttpsMutation,
    useGetPromotionListQuery,
    useLazyGetPromotionListQuery,
    useUpdatePromotionAvailabilityStatusMutation,
    useDeletePromotionMutation,
    useGetPromotionDetailsByIdMutation,
    useUpdatePromotionMutation,
    useUpdatePromotionImageMutation
} = PromotionService;